





























































































	import { Component, Vue,Prop,  Watch } from 'vue-property-decorator';
    import CallHistoryRow from './call-history/CallHistoryRow.vue';
    import * as moment from 'moment';
	import { store, CDR, StoreState ,Timezone} from '../../store';
	import { mapState } from 'vuex';
    import util from '../../lib/util'; 
    import VueElementLoading from 'vue-element-loading';
    import {RotateSquare2} from 'vue-loading-spinner';
    import JsonExcel from 'vue-json-excel/JsonExcel.vue';
    import momentTZ from 'moment-timezone';
    import drag from '@branu-jp/v-drag';  
    import XLSX from 'xlsx'; 
    import {saveAs} from 'file-saver'; 
    import AES from 'crypto-js/aes';
	import CryptoJS from 'crypto-js';     
	import QuickCall from '../../components/QuickCall.vue';
    import axios from 'axios'; 


	declare interface CallHistoryData {    
		cdrs: CDR[];
	}

	@Component({
        components: {
          CallHistoryRow,  RotateSquare2,VueElementLoading,  JsonExcel,QuickCall
		},
		computed: {  
			...mapState({
				'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
                'call_history': (state: StoreState) => (state.dashboard as any).call_history, 
                'showLoadMore': (state: StoreState) => (state.dashboard as any).call_history_load_more,
                'showLoading': (state: StoreState) => (state.dashboard as any).call_history_loader,
				'timezone': (state: StoreState) => state.reports.filters.timezone,
				 'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
			     'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
                 'devices': (state: StoreState) => (state.account as any).devices,
                  'voice_notification': (state: StoreState) =>state.dashboard.voice_notification , 
                  'voicemail_records': (state: StoreState) => state.reports.voicemail_records,
               'CALL_HISTORY_LOAD_MORE_VISIBLE': (state: StoreState)=>state.dashboard.call_history_load_more,

			})
        },
        directives: {
            drag
        }
    },
    )
	export default class CallHistory extends Vue {
    timezone!: Timezone;
        data() {
             return {
                isLoading:false,
				loading: false,
               
                AddContact:"/img/icons/add-contact-button.png",
                Mylistsorting:[],
                playing: false,
                display: false,
                src_url: 'https://files.musopen.org/media/73af689d-ad7a-48b9-8336-02b62f25e546.mp3?filename=Goldberg+Variations,+BWV+988+-+Aria.mp3&preview',
                progress: 0,
                duration: 0,
                current_time: '',
                show_modal: false,
                draggable: true,
                initalDragX: -1,
                title: 'dummy title',
				downloadIMG:'img/icons/Download-icon1.png',
                callhistory_loading:false,
                minDate : '',
				maxDate :'',
                maxtodayDate:'',
                start_date: null,
                end_date: null,
                downloading:false,
                callhistory_status:false,
                date_status:false
            }
		}
		
	
		
	 created() 
	{
        this.$data.callhistory_loading=true;
        this.$data.callhistory_status=true;
          this.$store.state.dashboard.call_history.bookmarks =[];
            this.$store.state.dashboard.call_history.cdrs =[];
            this.$data.maxtodayDate=this.$data.maxDate=this.$data.maxDate=new Date();
            this.$store.dispatch("getCallHistory").then(r =>  
             {
              this.$data.callhistory_status=this.filteredHistory.length!=0?true:false;
                this.$store.dispatch("getVoicemails").then(r =>
                {
                    this.$data.callhistory_status=this.filteredHistory.length!=0?true:false;
                    const vm_id = r.data.vm_id;
                        const body = JSON.parse(r.data.body);
                             var voice_notf=(this as any).voice_notification;
                            this.$store.dispatch('markVoicemailAsRead', voice_notf.id).then(r=>{
                            this.$store.commit("SET_NOTIFICATION_STATUS");//refresh notification list count
                            this.$store.commit('DELETE_NOTIFICATION', {notificationId: voice_notf.id});
                        });
                     
                        this.$data.callhistory_loading=false;
                }).catch(() => {
						this.$data.callhistory_loading=false;
					});
                    }).catch(() => {
						this.$data.callhistory_loading=false;
					});
	}  
	
		get fullName() {
				if((this as any).selectedContact) {
					return `${((this as any).selectedContact as any).first_name} ${((this as any).selectedContact as any).last_name}`;
				}
				else {
					return '';
				}
			}
	
		
		get filteredHistory() 
		{
				if(!(this as any).selectedContact) {
					return [];
				}
                var info=(this as any).call_history.cdrs;
                 var vmail=(this as any).voicemail_records;//// voicemail records
                 //console.log('here in cdgrr');
                 (this as any).call_history.cdrs.concat(vmail);
				return (this as any).call_history.cdrs.filter(e => {
					const full_name = `${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`;
					if(e.to_name && full_name.toLowerCase() === e.to_name.toLowerCase()) {
						return true;
					}
					if(e.from_name && full_name.toLowerCase() === e.from_name.toLowerCase()) {
						return true;
					}
					let numbers = [];
					if((this as any).selectedContact.extension  && (this as any).selectedContact.private) {
					//  for(const number of (this as any).selectedContact.numbers.main) 
						{
							numbers.push((this as any).selectedContact.extension );
						}
					}
					else
					if((this as any).selectedContact.numbers && (this as any).selectedContact.numbers.main) {
						for(const number of (this as any).selectedContact.numbers.main) {
							numbers.push(this.transformPhoneNumber((number as any).replace(/\D/, '') as never));
						}
					}
					if((this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
						numbers.push(this.transformPhoneNumber((this as any).selectedContact.numbers.mobile.number.replace(/\D/, '') as never));
					}
					if(
						e.to_number &&
						(numbers as any).includes(e.to_number.replace(/\D/, ''))
					) {
						return true;
					}
					if(
						e.from_number &&
						(numbers as any).includes(e.from_number.replace(/\D/, ''))
					) {     
						return true;
					}
					if(e.dialed_number) {
						if( e.dialed_number.length>1 && (numbers as any).includes(e.dialed_number.replace(/\D/, ''))) {
						return true;
						}
					}
					return false;
				});
		}

		get contactName() {
			if((this as any).selectedContact.first_name && (this as any).selectedContact.last_name) {
				return `${(this as any).selectedContact.first_name} ${(this as any).selectedContact.last_name}`;
			}
			else {
				return util.formatPhoneNumber((this as any).selectedContact.numbers.main[0]);
			}
        }

        async loadMore() {
            if (!this.$data.loading) {
                this.$data.loading = true;
                await this.$store.dispatch('getCallHistory', {bookmarks: JSON.stringify((this as any).call_history.bookmarks)});
                this.$data.loading = false;
            }
        }
          
        transformPhoneNumber(phone_number) {
            if(typeof phone_number !== "string") {
                return 'error';
            } else if (phone_number.length === 12) {
                return phone_number.slice(2);
            } else if (phone_number.length === 11) {
                return phone_number.slice(1);
            } else {
                return phone_number.slice(0, 10);
            }
        }

         grabbedScrubber(event) {
            this.$data.draggable = false;
            this.$data.initalDragX = event.clientX;
            this.pauseRecording();
            document.addEventListener('mousemove', this.mouseMoveListener);
            document.addEventListener('mouseup', this.mouseUpListener);
        }

        mouseMoveListener(e: any) {
            const scrubberWidth = (this.$refs.scrubber as any).clientWidth;
            const scrubberRects = (this.$refs.scrubber as any).getClientRects()[0];
            const relPosition = Math.floor(e.clientX - scrubberRects.left);
            if (relPosition <= 0) {
                this.$data.progress = 0;
            } else if(relPosition >= scrubberWidth) {
                this.$data.progress = 100;
            } else {
                this.$data.progress = Math.floor((relPosition/scrubberWidth)*100);
            }
            this.$data.current_time = (this.$data.duration*(this.$data.progress/100));
        }

        mouseUpListener() {
            (this.$refs.audio as HTMLAudioElement).currentTime = (this.$data.duration*(this.$data.progress/100));
            document.removeEventListener('mouseup', this.mouseUpListener);
            document.removeEventListener('mousemove', this.mouseMoveListener); 
            this.playRecording();  
        }



        closeModal() {
            this.pauseRecording();
            this.$data.show_modal = false;
        }

        playRecording() {
            this.$data.playing = true;
            (this.$refs.audio as HTMLAudioElement).play();
        }

        pauseRecording() {
            this.$data.playing = false;
            (this.$refs.audio as HTMLAudioElement).pause();
        }
        canplayaudio()
        {
            if (this.$refs.audio) {
                this.playRecording() ;
               this.$data.display=true;;
            }
        }

        updateDuration() {
            if (this.$refs.audio) {
                this.$data.duration = (this.$refs.audio as HTMLAudioElement).duration;
            }
        }
        
        updateCurrentCallTime(event) {
            this.$data.current_time = (this.$refs.audio as HTMLAudioElement).currentTime;
            this.$data.progress = Math.floor((this.$data.current_time/this.$data.duration)*100);
        }

        openModalcallhistory(payload) {
             this.$data.title = momentTZ(momentTZ(payload.timestamp, 'x').format()).tz(this.timezone.tz).format('YYYY-MM-DD hh:mm a');//title;
             this.$data.src_url =payload.call_recording//"https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_7659796@10.10.24.52.mp3";//payload.call_recording//
             this.$data.show_modal = true;
             this.$data.display = false;
              this.$emit('openModalcallhistory', payload);
        }
         openModal(title,src_url) {
            this.$data.title = title;//"0_3587859745@10.10.24.52";
            this.$data.src_url =src_url;// "https://s3-us-west-2.amazonaws.com/spokerecordings/173d9d1269761052da83512b3e47fbe7/call_recording_0_7659796@10.10.24.52.mp3";//src_url;//
            this.$data.show_modal = true;
            this.$data.display = false;
        }
        get formattedDuration() {
            let secs = Math.floor(this.$data.duration);
            const mins = Math.floor(secs / 60);
            secs %= 60;
            const sec_string = (secs.toString() as any).padStart(2, '0');
            return `${mins}:${sec_string}`;
        }

        get formattedCurrentTime() {
            let secs = Math.floor(this.$data.current_time);
            const mins = Math.floor(secs / 60);
            secs %= 60;
            const sec_string = (secs.toString() as any).padStart(2, '0');
            return `${mins}:${sec_string}`;
        }
       
        setmindate()
        {   this.$data.date_status=false;
			this.$data.minDate = new Date(this.$data.start_date);
		}

        setmaxdate()
        {   this.$data.date_status=false;
			this.$data.maxDate = new Date(this.$data.end_date);  
        }
        

    downloadXCLDOC() {
        if(this.filteredHistory.length!=0)
        var self=this;
       // this.$data.downloading=true;
            //if not select daterange download all records
        // if (this.$data.start_date==null)
        // { 
        //     this.down_loadMore();
        // }
        if (this.$data.start_date==null && this.$data.end_date==null
            ||(this.$data.start_date!==null&&this.$data.end_date==null) 
            || (this.$data.start_date==null&&this.$data.end_date!==null))
		{ 
			this.$data.date_status=true;
        }
        else{
            this.$data.downloading=true;
            this.$data.date_status=false;
            setTimeout(function(){
                //download record for selected date-range
                self.TextExcelDoc_download(1);   
            }, 1000);
        }
		}
    
    
          async down_loadMore() {
                await this.$store.dispatch('getCallHistory', {bookmarks: JSON.stringify((this as any).call_history.bookmarks)})
                .then(() => {
                var timestamp_0 = this.filteredHistory[0].timestamp;
                timestamp_0 = new Date(timestamp_0);
                timestamp_0=  timestamp_0.toISOString();
               // this.$data.minDate=this.$data.start_date=timestamp_l;//timestamp_0;
                var last_index=this.filteredHistory.length;
                var timestamp_l = this.filteredHistory[last_index-1].timestamp;
                timestamp_l = new Date(timestamp_l);
                timestamp_l=  timestamp_l.toISOString();
                this.$data.maxDate =this.$data.end_date=timestamp_0;//timestamp_l;;
                 this.$data.minDate=this.$data.start_date=timestamp_l;//timestamp_0;
                //if not select daterange download all records
                this.TextExcelDoc_download(2);
					});;
        }

		
         /**
		 * Download message history to  ExcelDoc file 
		 */
	   	TextExcelDoc_download(envt) 
		{
			var wb = XLSX.utils.book_new();
				var data = [
						['Call Direction','Dialed Number','Duration','From Name'
						,'From Number',"ID", 'Timestamp','To Name','To Number'],
					   ];
		
            var fromdate =this.$data.minDate;
           
            this.$data.end_date=this.$data.end_date==null?new Date():this.$data.end_date;
			var todate=	this.$data.maxDate ? this.$data.maxDate  : new Date();
        
            //if not select date-range download all call-records
            if(envt==2){
                var rec=  this.filteredHistory;
                for(var i=0; i< rec.length; i++)  
                    {
                        var durationf = function (value){
                            const duration = momentTZ.duration(+value, 'seconds');
                            return momentTZ.utc(duration.asMilliseconds()).format("mm:ss ")
                        };
                        var timestampf =function (value,tz){
                            return momentTZ(momentTZ(value, 'x').format()).tz(tz).format('YYYY-MM-DD hh:mm a')
                        }
                        var duration= durationf(rec[i].duration);
                        var timestamp= timestampf(rec[i].timestamp,this.timezone.tz);
                        data.push([rec[i].call_direction,rec[i].dialed_number,duration,rec[i].from_name
                        ,rec[i].from_number,rec[i].id,timestamp,rec[i].to_name,rec[i].to_number]);

                    }
            }
            //download record for selected date-range
            else{
                var rec1=  this.filteredHistory;
                rec1.forEach(rec =>{ 
                var timestamp = rec.timestamp;
                var date = new Date(timestamp);
                   var   date_=  date.toISOString();
                        if (moment(date_).isSameOrAfter(fromdate, 'day') 
								&& moment(date_).isSameOrBefore(todate, 'day')
							)
						{
                   
                    var durationf = function (value){
						const duration = momentTZ.duration(+value, 'seconds');
						return momentTZ.utc(duration.asMilliseconds()).format("mm:ss ")
                    };
                    var duration= durationf(rec.duration);
					
                    data.push([rec.call_direction,rec.dialed_number,duration,rec.from_name
					,rec.from_number,rec.id,moment(date_).format('YYYY-MM-DD  hh:mm a'),rec.to_name,rec.to_number]);
                    }
        			});
       
            } 
             this.$data.downloading=false;
				var n0=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[0]? o[0].length: 5; 
					}));
				var n1=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[1]? o[1].length: 5; 
					}));
				var n2=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[2]? o[2].length: 5; 
					}));
				var n3=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[3]? o[3].length: 5; 
					}));
				var n4=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[4]? o[4].length: 5; 
					}));
				var n5=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[5]? o[5].length: 5; 
					}));
				var n6=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[6]? o[6].length: 5; 
					}));
				var n7=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[7]? o[7].length: 5; 
					}));
				var n8=  Math.max.apply(Math, data.map(function(o) { 
					
					return o[8]? o[8].length: 5; 
					}));
				var wscols = [{wch:n0},{wch:n1},{wch:n2},{wch:n3},{wch:n4},{wch:n5+10},{wch:n6},{wch:n7},{wch:n8}];
				var wb = XLSX.utils.book_new();
				var ws = XLSX.utils.json_to_sheet(data, {skipHeader: true,cellDates:true});
				var range = XLSX.utils.decode_range(ws["!ref"]);
				if(!ws['!cols']) ws['!cols'] = [];
				if(!ws.A1.c) ws.A1.c = [];
				

				ws['!cols'] = wscols;
				ws["!margins"]={left:6.0, right:8.0, top:9.0, bottom:1.0, header:0.5,footer:0.5};
				XLSX.utils.book_append_sheet(wb, ws, "No Header");
					this.$data.isLoading=false;
				var wbout = XLSX.write(wb, {bookType:'xlsx', type:'array'}); 
				saveAs(new Blob([wbout],{type:"application/octet-stream"}), `${(this as any).selectedContact.first_name}_call_rec.xlsx`);

		}
}

